"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssessmentScoreEnum = exports.UserInteractionAssessmentType = void 0;
var UserInteractionAssessmentType;
(function (UserInteractionAssessmentType) {
    UserInteractionAssessmentType["ANSWER"] = "answer";
    UserInteractionAssessmentType["GRAMMAR"] = "grammar";
    UserInteractionAssessmentType["NATIVE"] = "native";
    UserInteractionAssessmentType["PRONUNCIATION"] = "pronunciation";
})(UserInteractionAssessmentType || (exports.UserInteractionAssessmentType = UserInteractionAssessmentType = {}));
var AssessmentScoreEnum;
(function (AssessmentScoreEnum) {
    AssessmentScoreEnum[AssessmentScoreEnum["LOWEST"] = 0] = "LOWEST";
    AssessmentScoreEnum[AssessmentScoreEnum["LOW"] = 40] = "LOW";
    AssessmentScoreEnum[AssessmentScoreEnum["MEDIUM"] = 60] = "MEDIUM";
    AssessmentScoreEnum[AssessmentScoreEnum["HIGH"] = 80] = "HIGH";
    AssessmentScoreEnum[AssessmentScoreEnum["HIGHEST"] = 100] = "HIGHEST";
})(AssessmentScoreEnum || (exports.AssessmentScoreEnum = AssessmentScoreEnum = {}));
//# sourceMappingURL=enums.js.map